// Six reasons page (sections/six-reasons-page.liquid). Paid traffic from the shelf-vs-craft ads lands
// here and every button goes to the quiz. This file runs the page (box carousel, member clips row,
// sticky bar, ticker pause), carries the visit's ad parameters onto every quiz link, and announces
// six-reasons:<state> events on document. assets/analytics-posthog-funnel.js names and sends them;
// window.__sixReasonsQueue keeps the ones that fire before that file loads.
(function () {
  var root = document.querySelector('[data-six-reasons]');
  if (!root || root.__sixReasons) return;
  root.__sixReasons = true;

  var queue = (window.__sixReasonsQueue = window.__sixReasonsQueue || []);
  function announce(state, detail) {
    queue.push({ state: state, detail: detail || {} });
    try {
      document.dispatchEvent(new CustomEvent('six-reasons:' + state, { detail: detail || {} }));
    } catch (e) {}
  }

  // Member clip stills (data-poster) load when the row comes within 600px of the screen, as on the
  // six ways page. The clips themselves stay preload="none" until tapped.
  (function () {
    function stills(row) {
      row.querySelectorAll('video[data-poster]').forEach(function (v) {
        v.setAttribute('poster', v.getAttribute('data-poster'));
        v.removeAttribute('data-poster');
      });
    }
    var rows = root.querySelectorAll('.wlb-ugc');
    if (!('IntersectionObserver' in window)) { rows.forEach(stills); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { stills(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    rows.forEach(function (r) { io.observe(r); });
  })();

  // Ad parameters: read from this URL, else from the copy kept for this tab (a reload or a back
  // from the quiz can drop the query string), then added to every quiz link that lacks them.
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  var STORE = 'wl_six_reasons_params';
  var params = {};
  try {
    var q = new URLSearchParams(window.location.search || '');
    KEYS.forEach(function (k) { var v = q.get(k); if (v) params[k] = v; });
    if (Object.keys(params).length) sessionStorage.setItem(STORE, JSON.stringify(params));
    else params = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {};
  } catch (e) {}
  var quizLinks = root.querySelectorAll('a[href*="/pages/quiz-questions"]');
  quizLinks.forEach(function (a) {
    try {
      var url = new URL(a.getAttribute('href'), window.location.origin);
      Object.keys(params).forEach(function (k) { if (!url.searchParams.has(k)) url.searchParams.set(k, params[k]); });
      a.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (e) {}
  });

  announce('viewed', { utm_term: params.utm_term || null, utm_campaign: params.utm_campaign || null });

  // The order records which page the buyer saw: one cart attribute, written once per tab session
  // on the first quiz click, as on the six ways page.
  var TAGGED = 'six_reasons_cart_tagged';
  function tagCart() {
    try {
      if (sessionStorage.getItem(TAGGED)) return;
    } catch (e) { return; }
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _landingPage: 'six-reasons' } })
      }).then(function (r) {
        // Mark only a saved attribute, so a failed request retries on the next click.
        if (r.ok) { try { sessionStorage.setItem(TAGGED, '1'); } catch (e) {} }
      }).catch(function () {});
    } catch (e) {}
  }

  quizLinks.forEach(function (a, i) {
    a.addEventListener('click', function () {
      tagCart();
      var where = a.closest('[data-six-reasons-cta]');
      announce('quiz_clicked', {
        cta: where ? where.getAttribute('data-six-reasons-cta') : 'button_' + (i + 1),
        utm_term: params.utm_term || null
      });
    });
  });

  // Phone sticky bar: shown only when no in-page quiz button is on screen.
  var sticky = root.querySelector('#sticky');
  var btns = root.querySelectorAll('.quiz-btn');
  if (sticky && btns.length && 'IntersectionObserver' in window) {
    var vis = new Set();
    var sio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) vis.add(e.target); else vis.delete(e.target); });
      sticky.classList.toggle('sr-sticky--hidden', vis.size > 0);
    });
    btns.forEach(function (b) { sio.observe(b); });
  }

  // Ticker pause button (WCAG 2.2.2); hover and focus pauses are CSS (six-reasons.css).
  var ticker = root.querySelector('.sr-ticker');
  var tickerBtn = ticker && ticker.querySelector('[data-ticker-toggle]');
  if (tickerBtn) {
    tickerBtn.addEventListener('click', function () {
      var paused = tickerBtn.getAttribute('aria-pressed') !== 'true';
      tickerBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      ticker.classList.toggle('sr-ticker--paused', paused);
      announce('ticker_toggled', { paused: paused });
    });
  }

  // Member clips: the still shows until play is tapped; one plays at a time, with sound.
  var vids = root.querySelectorAll('.wlb-ugc video');
  root.querySelectorAll('.sr-clip__play').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      var v = btn.parentNode.querySelector('video');
      if (!v) return;
      btn.hidden = true;
      v.controls = true;
      try { v.focus(); } catch (e) {}
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      announce('clip_played', { clip: i + 1 });
    });
  });
  vids.forEach(function (v) {
    v.addEventListener('play', function () {
      vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
    });
  });

  // Member clips row: arrows scroll by one clip, the gold bar follows the scroll position.
  var row = root.querySelector('[data-reviews-row]');
  if (row) {
    var thumb = root.querySelector('.sr-reviews__thumb');
    var rPrev = root.querySelector('.sr-reviews__btn--prev');
    var rNext = root.querySelector('.sr-reviews__btn--next');
    var step = function () {
      var c = row.querySelector('.sr-clip');
      return c ? c.getBoundingClientRect().width + 8 : 150;
    };
    var syncRow = function () {
      var max = row.scrollWidth - row.clientWidth;
      var f = max > 1 ? Math.min(1, Math.max(0, row.scrollLeft / max)) : 0;
      if (thumb) thumb.style.left = (f * (100 - 33.333)) + '%';
      // When every clip fits, both arrows stay at full strength, as drawn.
      if (rPrev) rPrev.disabled = max > 1 && row.scrollLeft <= 1;
      if (rNext) rNext.disabled = max > 1 && row.scrollLeft >= max - 1;
    };
    if (rPrev) rPrev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (rNext) rNext.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', syncRow, { passive: true });
    window.addEventListener('resize', syncRow);
    syncRow();
  }

  // Member box carousel: the phone and the desktop show different picture sets (slides and dots
  // marked --m are phone only, --d desktop only), so only the slides on screen count. Arrows and dots move one
  // slide; each move (dot, arrow or swipe) is announced once, 1-based.
  root.querySelectorAll('[data-carousel]').forEach(function (p) {
    var track = p.querySelector('[data-carousel-track]');
    if (!track) return;
    var allSlides = track.querySelectorAll('.sr-car__slide');
    var allDots = p.querySelectorAll('.sr-car__dot');
    var shown = function (list) {
      return Array.prototype.filter.call(list, function (el) { return el.offsetParent !== null; });
    };
    var current = 0;
    var method = null;
    var settle = null;
    function index() {
      var slides = shown(allSlides);
      if (!slides.length) return 0;
      var base = slides[0].offsetLeft;
      var best = 0;
      var dist = Infinity;
      slides.forEach(function (s, k) {
        var d = Math.abs(s.offsetLeft - base - track.scrollLeft);
        if (d < dist) { dist = d; best = k; }
      });
      // At the right end the last slide may never reach the left edge.
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) best = slides.length - 1;
      return best;
    }
    function paint(i) {
      shown(allDots).forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
        d.setAttribute('aria-label', 'Show box ' + (k + 1));
      });
    }
    function go(i, how) {
      var slides = shown(allSlides);
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      method = how;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    var prev = p.querySelector('.sr-car__btn--prev');
    var next = p.querySelector('.sr-car__btn--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, 'arrow'); });
    if (next) next.addEventListener('click', function () { go(current + 1, 'arrow'); });
    allDots.forEach(function (d) {
      d.addEventListener('click', function () { go(shown(allDots).indexOf(d), 'dot'); });
    });
    track.addEventListener('scroll', function () {
      var i = index();
      paint(i);
      clearTimeout(settle);
      settle = setTimeout(function () {
        var now = index();
        if (now !== current) {
          current = now;
          announce('carousel_changed', { method: method || 'swipe', slide: now + 1 });
        }
        method = null;
      }, 150);
    }, { passive: true });
    window.addEventListener('resize', function () { current = index(); paint(current); });
    paint(0);
  });
})();
